<template>
  <daiban-tool :flow="flow"> </daiban-tool>
</template>
<script>
import daibanTool from "./daibanTool.vue";
export default {
  components: { daibanTool },
  data() {
    return {
      flow: {
          id: "1611273939011809286",
          name: "日常保洁",
          name1: "保洁待办处理",
        },
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/components/yhgl/daibanchuli.vue